(() => {
  if (customElements.get('klove-autumn-banner')) return;
  customElements.define('klove-autumn-banner', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.checkExpiry = () => {
        clearTimeout(this.expiryTimer);
        const remaining = Date.parse(this.dataset.expires) - Date.now();
        if (!Number.isFinite(remaining) || remaining <= 0) {
          this.hidden = true;
          return;
        }
        // Recheck daily and after returning to an open tab; avoid timer overflow.
        this.expiryTimer = setTimeout(this.checkExpiry, Math.min(remaining, 86400000));
      };
      document.addEventListener('visibilitychange', this.checkExpiry, { signal: this.events.signal });
      this.checkExpiry();
    }
    disconnectedCallback() {
      this.events?.abort();
      clearTimeout(this.expiryTimer);
    }
  });
})();
